// @flow

import React, {Component} from 'react'

import Search from '../../common/components/Search'
import MedicineList from './MedicineList'
import css from './Main.css'
import {DEFAULT_TEXTS} from '../../common/constants'

type Props = {
  titleText: string,
  descriptionText: string,
  placeholderText: string,
  instructionText: string,
  isFetching: boolean,
  medicineAmount: number,
  medicineItems: Array<Object>,
  onLoadMore: Function,
  showLoadMore: boolean,
  onSearch: Function,
  showSearch: boolean,
  showQrCodeText: boolean,
  keyword: ?string,
  onKeywordChange: Function,
  showMedicineList: boolean,
  showMedicineInfo: boolean,
  urlKeyword: ?string
}

class Main extends Component {
  props: Props

  render() {
    const {
      titleText,
      descriptionText,
      placeholderText,
      instructionText,
      isFetching,
      medicineAmount,
      medicineItems,
      onLoadMore,
      showLoadMore,
      onSearch,
      showSearch,
      showQrCodeText,
      keyword,
      onKeywordChange,
      showMedicineList,
      showMedicineInfo,
      urlKeyword,
    } = this.props

    return (
      <div className={css.component}>
        <div className={css.wrapper}>
          <h1 className={css.title}>
            {titleText
              ? titleText
              : DEFAULT_TEXTS.searchTitle
            }
          </h1>
          <p className={css.text}>
            {descriptionText
              ? descriptionText
              : DEFAULT_TEXTS.searchDescription
            }
          </p>
          {showSearch && (
            <Search
              placeholderText={placeholderText}
              instructionText={instructionText}
              keyword={keyword}
              onChange={value => onKeywordChange(value)}
              onSearch={(keyword) => onSearch(keyword)}
              sizeL={true}
            />
          )}
          {showMedicineList && (
            <MedicineList
              urlKeyword={urlKeyword}
              showQrCodeText={showQrCodeText}
              medicineAmount={medicineAmount}
              medicines={medicineItems}
              isFetching={isFetching}
              showLoadMore={showLoadMore}
              onLoadMore={() => onLoadMore()}
              showMedicineInfo={showMedicineInfo}
            />
          )}
        </div>
      </div>
    )
  }
}

export default Main



// WEBPACK FOOTER //
// ./src/homepage/components/Main.js